import React, { useContext, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, FormControl, Typography, Select, Checkbox, FormControlLabel, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MuiAlert from '@material-ui/lab/Alert';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';
import HistoryIcon from '@material-ui/icons/History';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { MTableToolbar } from 'material-table';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    mb10: {
        marginBottom: "10px"
    },
    mb5: {
        marginBottom: "5px"
    }
}));

const SignHandOffAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const { patientSittings, patientSittingDto, attendants, siteId, onHideSignHandOffConfirm, checkAttendantWithMultiple, savePatientSitting, close, onDisableWithStyle } = props;
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);
    const [signHandOffDto, setSignHandOffDto] = useState([]);
    const [attendantSelected, setAttendantSelected] = useState({ FirstName: "", LastName: "" });
    const [showSignHandOffHistory, setShowSignHandOffHistory] = useState(false);
    const [clinicalCheckboxShow, setClinicalCheckboxShow] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [reasons] = useState([
        { Name: "Shift Change" },
        { Name: "Break" },
        { Name: "Lunch" },
        { Name: "End of Break" },
        { Name: "End of Lunch" },
        { Name: "End of Observation" },
        { Name: "Other" }
    ]);

    const [signHandOffHistorys, setSignHandOffHistorys] = useState({
        columns: [
            { field: 'DutyAttendant', title: 'On-Duty Attendant' },
            { field: 'ReplacementAttendant', title: 'Replacement Attendant' },
            { field: 'Reason', title: 'Reason' },
            { field: 'Comments', title: 'Comments' },
            { field: 'SignOffAuthorization', title: 'Sign Off Authorization' },
            { field: 'CreatedDateTimeString', title: 'Created Date' },
            { field: 'CreatedUser', title: 'Create User' },
        ],
        data: [],
        count: 0
    });

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const onAttendantSelected = (event, values, id) => {
        if (values?.AppUserName) {
            var name = (values.FirstName == null ? '' : values.FirstName) + " " + (values.LastName == null ? '' : values.LastName);
            setSignHandOffDto({ ...signHandOffDto, ReplacementAttendant: name, ReplacementAttendantUsername: values.AppUserName });
            setAttendantSelected(values);
        }

    };

    const onReasonChanged = (event, item) => {

        if (event.target.value !== 'End of Observation') {
            setSignHandOffDto({ ...signHandOffDto, SignOffAuthorization: "" });
        }

        setSignHandOffDto({ ...signHandOffDto, Reason: event.target.value });
    };

    const fillSignHandOff = (dto) => {
        var _signHandOffDto = {};
        _signHandOffDto.Id = dto.Id;
        _signHandOffDto.AppPatientSittingId = patientSittingDto.Id;
        _signHandOffDto.DutyAttendant = patientSittingDto.Attendant;
        _signHandOffDto.DutyAttendantUsername = patientSittingDto.AttendantUsername;
        _signHandOffDto.ReplacementAttendant = "";
        _signHandOffDto.ReplacementAttendantUsername = null;
        _signHandOffDto.ClinicalAttendant = "";
        _signHandOffDto.ClinicalNotes = "";
        _signHandOffDto.IsClinicalRelief = false;
        _signHandOffDto.Reason = null;
        _signHandOffDto.Comments = null;
        _signHandOffDto.SignOffAuthorization = null;
        setSignHandOffDto(_signHandOffDto);
    };

    const clinicalHandOffEnabled = () => {

        HttpService.post('/PatientSitting/IsClinicalHandOffEnabled',
            { siteId: siteId }
        )
            .then((result) => {
                if (result.data.FirstName === "Clinical") {
                    setClinicalCheckboxShow(true);
                }
            },
                (error) => {

                });
    };

    const getSignHandOff = () => {

        HttpService.post('/PatientSitting/GetSignHandOff',
            { AppPatientSittingId: patientSittingDto.Id }
        )
            .then((result) => {
                fillSignHandOff(result.data);

                if (result.data.Id > 0) {
                    getSignHandOffHistorys(result.data.Id);
                }

            },
                (error) => {

                });
    };

    const getSignHandOffHistorys = (id) => {

        HttpService.post('/PatientSitting/GetSignHandOffHistorys',
            { Id: id }
        )
            .then((result) => {
                setSignHandOffHistorys({ ...signHandOffHistorys, data: result.data });
            },
                (error) => {

                });
    };

    const saveSignHandOff = () => {
        var dto = signHandOffDto;
        
        if (dto.IsClinicalRelief === true) {
            if (!dto.ClinicalAttendant) {
                setErrorMessage("Please enter a valid Clinical Attendant.");
                setOpenError(true);
                return false;
            }

            dto.ReplacementAttendantUsername = dto.ClinicalAttendant;
            dto.ReplacementAttendant = dto.ClinicalAttendant;
        }

        if (!dto.DutyAttendantUsername) {
            setErrorMessage("Please enter a valid On-Duty Attendant.");
            setOpenError(true);
            return false;
        }

        if (!dto.ReplacementAttendantUsername && dto.Reason !== "End of Observation" && dto.IsClinicalRelief === false) {
            setErrorMessage("Please enter a valid Replacement Attendant.");
            setOpenError(true);
            return false;
        }

        if (dto.DutyAttendantUsername === dto.ReplacementAttendantUsername) {
            setErrorMessage("On-Duty Attendant and Replacement Attendant must be different.");
            setOpenError(true);
            return false;
        }

        if (!dto.Reason) {
            setErrorMessage("Please select a  Reason.");
            setOpenError(true);
            return false;
        }

        if (dto.Reason === "Other") {
            if (!dto.Comments) {
                setErrorMessage("Please enter an Comments.");
                setOpenError(true);
                return false;
            }
        }

        if (dto.Reason === "End of Observation") {
            if (!dto.SignOffAuthorization) {
                setErrorMessage("Please enter an Sign Off Authorization.");
                setOpenError(true);
                return false;
            }
        }

        var checkDto = {
            AttendantUsername: dto.ReplacementAttendantUsername,
            SiteId: siteId
        };
        
        if (dto.Reason === "End of Observation" || dto.IsClinicalRelief === true) {
            checkSignHandOff();
        }
        else
            checkAttendantWithMultiple(checkDto, checkSignHandOff);
    };

    const checkSignHandOff = () => {
        var dto = signHandOffDto;

        var app = patientSittings.filter(x => x.Id === patientSittingDto.Id);
        var signHandOff = app !== null ? app[0].signHandOff : null;

        if (signHandOff !== null) {
            if (signHandOff.IsClinicalRelief === true && dto.IsClinicalRelief === true) {
                setErrorMessage("Clinical Relief is already active. Only hand off to POA is allowed.");
                setOpenError(true);
                signHandOffDto.ReplacementAttendant = "";
                signHandOffDto.ReplacementAttendantUsername = null;
                return;
            }
        }
        if (dto.IsClinicalRelief === true) {
            dto.ReplacementAttendant = dto.ClinicalAttendant;
            dto.ReplacementAttendantUsername = dto.ClinicalAttendant;
            submitSignHandOff();
        }
        else
            submitSignHandOff();
    };

    const submitSignHandOff = () => {
        onDisableWithStyle(true);
        HttpService.post('/PatientSitting/SaveSignHandOff',
            signHandOffDto
        )
            .then((result) => {
                close();
                savePatientSitting(true);
            },
                (error) => {

                });
    };

    useImperativeHandle(ref, () => {
        return {
            save: saveSignHandOff
        };
    });

    useEffect(() => {
        if (patientSittingDto.Id > 0) {
            getSignHandOff();
            onDisableWithStyle(false);
        }

        clinicalHandOffEnabled();
        // eslint-disable-next-line 
    }, []);

    return (
        <div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            {
                signHandOffHistorys.data.length > 0
                &&
                <Grid container
                    direction="row"
                    justify="flex-end"
                    alignItems="flex-start"
                    className={classes.mb5}
                    spacing={2}
                >
                    <Grid item>
                        {!showSignHandOffHistory && <HistoryIcon fontSize="large" style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => { onHideSignHandOffConfirm(true); setShowSignHandOffHistory(true); }} />}
                        {showSignHandOffHistory && <KeyboardReturnIcon fontSize="large" style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => { setShowSignHandOffHistory(false); onHideSignHandOffConfirm(false); }} />}
                    </Grid>
                </Grid>
            }

            {
                !showSignHandOffHistory
                &&
                <>
                    <Typography variant="subtitle2" gutterBottom>
                        On-Duty Attendant <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField size="small" fullWidth
                        variant="outlined"
                        disabled={true}
                        className={classes.mb10}
                        value={signHandOffDto.DutyAttendant || ""}
                        onChange={(e) => { setSignHandOffDto({ ...signHandOffDto, DutyAttendant: e.target.value.trim() }); }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {
                        clinicalCheckboxShow
                        && signHandOffDto.Reason !== 'End of Observation'
                        &&
                        <FormControlLabel
                            label="Clinical Relief"
                            control={
                                <Checkbox
                                    checked={signHandOffDto.IsClinicalRelief || false}
                                    onChange={(e) => { setSignHandOffDto({ ...signHandOffDto, IsClinicalRelief: e.target.checked }) }}
                                    value="checkedA"
                                />
                            }
                            style={{ color: currentTheme.text }}
                        />
                    }

                    {signHandOffDto.IsClinicalRelief
                        &&
                        <>
                            <Typography variant="subtitle2" gutterBottom>
                                Clinical Attendant <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <TextField size="small" fullWidth
                                variant="outlined"
                                className={classes.mb5}
                                value={signHandOffDto.ClinicalAttendant || ""}
                                onChange={(e) => { setSignHandOffDto({ ...signHandOffDto, ClinicalAttendant: e.target.value.trim() }); }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </>
                        
                    }

                    {
                        !signHandOffDto.IsClinicalRelief
                        && signHandOffDto.Reason !== 'End of Observation'
                        &&
                        <>
                            <Typography variant="subtitle2" gutterBottom>
                                Replacement Attendant <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <Autocomplete
                                size="small"
                                id="Attendant"
                                options={attendants || []}
                                className={classes.mb5}
                                getOptionLabel=
                                {
                                    (option) => `${option?.FirstName == null ? '' : option.FirstName} ${option?.LastName == null ? '' : option.LastName}`
                                }
                                value={attendantSelected}
                                filterSelectedOptions
                                getOptionSelected={(option, value) => option.FirstName === value.FirstName}
                                onChange={(e, v) => onAttendantSelected(e, v, 13)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Attendant"
                                    />
                                )}
                            />
                        </>
                    }

                    <Typography variant="subtitle2" gutterBottom className="mt-2">
                        Reason <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl variant="outlined" margin="dense" fullWidth style={{ marginTop:"-5px" }}>
                        <Select
                            native
                            size="small"
                            value={signHandOffDto.Reason || ""}
                            onChange={(e) => onReasonChanged(e)}
                        >
                            <option aria-label="None" key="0" value="" disabled/>
                            {
                                reasons.map((option, key) => {
                                    return <option key={option.Name} value={option.Name} label={option.Name} >{option.Name}</option>;
                                })
                            }
                        </Select>
                    </FormControl>
                    <Typography variant="subtitle2" gutterBottom>
                        Comments 
                    </Typography>
                    <TextField size="small" fullWidth
                        variant="outlined"
                        value={signHandOffDto.Comments || ""}
                        className={classes.mb10}
                        onChange={(e) => { setSignHandOffDto({ ...signHandOffDto, Comments: e.target.value.trimStart() }); }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    {
                        signHandOffDto.Reason === 'End of Observation'
                        &&
                        <>
                            <Typography variant="subtitle2" gutterBottom>
                                Sign Off Authorization <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <TextField size="small" fullWidth
                                variant="outlined"
                                value={signHandOffDto.SignOffAuthorization || ""}
                                onChange={(e) => { setSignHandOffDto({ ...signHandOffDto, SignOffAuthorization: e.target.value.trimStart() }); }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </>
                    }
                </>
            }

            {
                showSignHandOffHistory
                &&
                <MaterialTable
                    title=""
                    columns={signHandOffHistorys.columns}
                    data={signHandOffHistorys.data}
                    components={{
                        Toolbar: (props) => (
                            <div
                                style={{
                                    height: "0px",
                                }}
                            >
                                <MTableToolbar {...props} />
                            </div>
                        )
                    }}
                    style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                    options={{
                        filtering: false,
                        search: false,
                        paging: false,
                        actionsColumnIndex: -1,
                        minBodyHeight: "55vh", maxBodyHeight: "55vh",
                        headerStyle: {
                            fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                        },
                        actionsCellStyle: {
                            color: currentTheme.secondary,
                            hover: 'white'
                        },
                        rowStyle: rowStyle
                    }}
                />

            }
        </div>
    );
});
export default SignHandOffAdd;